import { z } from 'zod';
/**
 * Cursor-based pagination skeleton.
 * Offset pagination is intentionally not used (Mobile First / stable sort).
 */
export const DEFAULT_PAGE_LIMIT = 20;
export const MAX_PAGE_LIMIT = 50;
export const paginationQuerySchema = z.object({
    /** Opaque cursor encoding `(created_at, id)`. */
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(MAX_PAGE_LIMIT).default(DEFAULT_PAGE_LIMIT),
});
//# sourceMappingURL=pagination.js.map